import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import _ from 'lodash';
import {
  modifyPageLayoutComponents,
  EditorFooter as pageFooterTemplate
} from '../PageLayout';
import template from '../../templates/StoneSetupContent.rt';
import pageHeaderTemplate from '../../templates/StoneSetupPageHeader.rt';
import * as actions from '../../actions';
import {
  selectSearchTerm,
  getFilteredUpdatedStones
} from '../../selectors';
import * as editorNames from '../../constants/editorNames';
import {forceCheck} from 'react-lazyload';
import {AccessRights} from './../../schemas/accessRightsModel';
import $ from 'jquery';

const trimAndLowerCase = (text) => _.trim(text).toLowerCase();

const stoneSort = (a, b) => {
  let aName = trimAndLowerCase(a.name);
  let bName = trimAndLowerCase(b.name);

  if (a.fabricatorStoneData && a.fabricatorStoneData.customStoneName && a.fabricatorStoneData.customStoneName.length > 0)
    aName = trimAndLowerCase(a.fabricatorStoneData.customStoneName);
  if (b.fabricatorStoneData && b.fabricatorStoneData.customStoneName && b.fabricatorStoneData.customStoneName.length > 0)
    bName = trimAndLowerCase(b.fabricatorStoneData.customStoneName);

  if (aName < bName)
    return -1;
  else if (aName > bName)
    return 1;
  return 0;
}

function mapStateToProps(state) {
  let updatedStones = getFilteredUpdatedStones(state, state.auth.fabricatorId); //memoization per fabricator instead of globally to preven as user leaking site admin stones
  let enabledStones = updatedStones.filter(us => us.fabricatorStoneData && us.fabricatorStoneData.enabled);
  let disabledStones = updatedStones.filter(us => (us.fabricatorStoneData === null || us.fabricatorStoneData.enabled === false));

  enabledStones.sort(stoneSort);
  disabledStones.sort(stoneSort);
  return {
    term: selectSearchTerm(state),
    stones: updatedStones,
    enabledStones,
    disabledStones,
    AR: AccessRights.get(state)
  }
}

function mapDispatchToProps(dispatch) {
  return {
    loadPresets: () => dispatch(actions.pricingPresets.loadPresets()),
    fetchStones: () => dispatch(actions.loadAndFetchStones()),
    setSearchTerm: (term) => dispatch(actions.setSearchTerm(term)),
    onLoadEditor: () => dispatch(actions.loadEditor(editorNames.STONE_SETUP)),
    onUnloadEditor: () => dispatch(actions.unloadEditor()),
    enableAllTransientStones: (stones, enable) => dispatch(actions.enableAllFabricatorStones(stones, enable)),
    showNewStonePopup: () => dispatch(actions.newStone.showNewStonePopup(true))
  };
}

class StoneSetupContent extends React.Component {
  componentWillMount() {
    this.props.onLoadEditor();
    this.props.loadPresets()
      .then(() => this.props.fetchStones());
  }

  forcedUpdate = () => this._isMounted && this.forceUpdate();

  componentDidMount() {
    $('*').on('scroll', this.componentDidUpdate);
    document.removeEventListener('stones-loading', this.forcedUpdate);
    document.addEventListener('stones-loading', this.forcedUpdate);
    this._isMounted = true;
  }

  componentDidUpdate() {
    //forceCheck();
  }

  componentWillUnmount() {
    this.props.setSearchTerm('');
    this.props.onUnloadEditor();
    $('*').off('scroll', this.componentDidUpdate);
    this._isMounted = false;
  }

  render() {
    return template.apply(this);
  }

  enableAllTransientStones = (enable) => {
    let stones = this.props.enabledStones;
    if (enable) {
      stones = this.props.disabledStones;
    }
    this.props.enableAllTransientStones(stones, enable)
  }
}

StoneSetupContent.propTypes = {
  fetchStones: PropTypes.func.isRequired,
  setSearchTerm: PropTypes.func.isRequired,
  onLoadEditor: PropTypes.func.isRequired,
  onUnloadEditor: PropTypes.func.isRequired
};

const connector = connect(mapStateToProps, mapDispatchToProps);

const StoneSetupContentContainer = connector(StoneSetupContent);
const StoneSetupPageHeader = pageHeaderTemplate;
const StoneSetupPageFooter = pageFooterTemplate;

export const StoneSetupLayoutComponents = modifyPageLayoutComponents({
  pageHeader: connector(StoneSetupPageHeader),
  content: StoneSetupContentContainer,
  pageFooter: StoneSetupPageFooter
});

export {StoneSetupCard} from './card';
